import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';

var _tokens$colors = tokens.colors,
  white = _tokens$colors.text.static_icons__primary_white.rgba,
  background = _tokens$colors.ui.background__overlay.rgba,
  ui = tokens.typography.ui,
  _tokens$spacings$comf = tokens.spacings.comfortable,
  spacingXlarge = _tokens$spacings$comf.x_large,
  spacingSmall = _tokens$spacings$comf.small,
  borderRadius = tokens.shape.corners.borderRadius;
var tooltip = {
  typography: _objectSpread(_objectSpread({}, ui.tooltip), {}, {
    color: white
  }),
  background: background,
  border: {
    type: 'border',
    radius: borderRadius
  },
  entities: {
    tooltip: {
      height: spacingXlarge
    },
    arrow: {
      width: '6px',
      height: spacingSmall,
      spacings: {
        bottom: '-6px',
        top: '-6px',
        left: '-6px',
        right: '-6px'
      }
    }
  },
  spacings: {
    left: spacingSmall,
    right: spacingSmall,
    top: spacingSmall,
    bottom: spacingSmall
  }
};

export { tooltip };
